import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-directive-svg",
  templateUrl: "./directive-svg.component.html",
  styleUrls: ["./directive-svg.component.scss"],
})
export class DirectiveSvgComponent implements OnInit {
  @Input() icon!: string;
  constructor() {}

  ngOnInit() {}
}
